import { render, staticRenderFns } from "./AdminLayout.vue?vue&type=template&id=63d14c66&"
import script from "./AdminLayout.vue?vue&type=script&lang=js&"
export * from "./AdminLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Alert: require('/var/www/vhosts/bloonde.es/lareverdetienda.bloonde.es/components/core/Alert.vue').default,Header: require('/var/www/vhosts/bloonde.es/lareverdetienda.bloonde.es/components/blocks/Header.vue').default,NavbarAdmin: require('/var/www/vhosts/bloonde.es/lareverdetienda.bloonde.es/components/blocks/NavbarAdmin.vue').default,Footer: require('/var/www/vhosts/bloonde.es/lareverdetienda.bloonde.es/components/blocks/Footer.vue').default})
